import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';
import { PropsWithChildren } from 'react';

interface SharedDialogProps {
  open: boolean;
  title: string;
  cancelText?: string;
  onCancel(): void;
  submit: JSX.Element;
}
export function SharedDialog({
  open,
  title,
  children,
  onCancel,
  cancelText = 'cancel',
  submit,
}: PropsWithChildren<SharedDialogProps>) {
  return (
    <Dialog open={open}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>{children}</DialogContent>
      <DialogActions>
        <Button onClick={onCancel} variant='contained'>
          {cancelText}
        </Button>
        {submit}
      </DialogActions>
    </Dialog>
  );
}
